import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, chakra, forwardRef, Icon } from '@chakra-ui/react';
import { useSidebarStyles } from './SidebarContext';
export const SidebarHeader = forwardRef(({ children, icon, iconProps, ...props }, ref) => {
    const styles = useSidebarStyles();
    return (_jsx(chakra.li, { listStyleType: "none", children: _jsxs(Box, { as: "h2", __css: styles.header, ref: ref, ...props, children: [icon ? _jsx(Icon, { as: icon, __css: styles.icon, ...iconProps }) : null, children] }) }));
});
SidebarHeader.displayName = 'SidebarHeader';
